import tophat from "./module";

export default tophat();
